module.exports = __webpack_public_path__ + "components/outside-promo-page/static/weather-forecast__icon-6d9621e525701e54c6f4c535e6ccbaf1.svg";